import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Dialog } from "@core/material";
import { Subject } from "rxjs";

@Component({
    selector: 'pv-evaluation-import-help-dialog',
    templateUrl: './evaluation-import-help.dialog.html',
    styleUrls: ['./evaluation-import-help.dialog.scss']
})
export class EvaluationImportHelpDialog implements OnDestroy {

    private _destroy$ = new Subject();

    constructor(
        private _dialogRef: MatDialogRef<EvaluationImportHelpDialog>,
        private _dialog: Dialog,
    ) { }


    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}